webpackJsonp([98],{

/***/ 2515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audio_asr_check_prompt__ = __webpack_require__(3175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audio_asr_check_question_io__ = __webpack_require__(3176);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var questionKey = 1;

function wrapQuestion(item) {
  return {
    _key: item.id ? 'id-' + item.id : questionKey++,
    id: item.id || undefined,
    alias: item.alias || '',
    question: item.question || '',
    risk_answer: item.risk_answer || ''
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var checkPrompt = function checkPrompt(rule, value, callback) {
      if (!value || !String(value).trim()) {
        callback(new Error('请输入提示词模板'));
        return;
      }
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__audio_asr_check_prompt__["b" /* validatePromptTemplate */])(value)) {
        callback(new Error('提示词模板必须包含 {{问题列表}} 与 {{ASR识别结果}}'));
        return;
      }
      callback();
    };
    return {
      formExpanded: true,
      pageLoading: false,
      submitting: false,
      previewLoading: false,
      importingQuestions: false,
      promptConfigLoaded: false,
      promptPreviewVisible: false,
      previewPrompt: '',
      promptFixedExpanded: [],
      defaultPromptBody: '',
      defaultQuestions: [],
      fixedPromptSuffix: '',
      isReferenced: false,
      form: {
        title: '',
        prompt_template: '',
        // 新建默认题目只从后端 prompt_config 拉取，避免前后端各维护一份
        questions: []
      },
      formRules: {
        title: [{ required: true, message: '请输入配置标题', trigger: 'blur' }, { max: 255, message: '配置标题最多 255 个字符', trigger: 'blur' }],
        prompt_template: [{ required: true, validator: checkPrompt, trigger: 'blur' }]
      }
    };
  },

  computed: {
    templateId: function templateId() {
      return this.$route.params.id ? Number(this.$route.params.id) : 0;
    },
    isEdit: function isEdit() {
      return !!this.templateId;
    },
    isReadonly: function isReadonly() {
      return this.isEdit && this.isReferenced;
    }
  },
  created: function created() {
    this.loadPromptConfig();
    if (this.isEdit) {
      this.loadDetail();
    }
  },

  methods: {
    loadPromptConfig: function loadPromptConfig() {
      var _this = this;

      request.common('getAudioAsrCheckPromptConfig').then(function (_ref) {
        var data = _ref.data;

        _this.defaultPromptBody = data.default_template_body || '';
        _this.fixedPromptSuffix = data.fixed_template_suffix || '';
        _this.defaultQuestions = Array.isArray(data.default_questions) ? data.default_questions : [];
        _this.promptConfigLoaded = true;
        if (!_this.isEdit) {
          if (!_this.form.prompt_template) {
            _this.form.prompt_template = _this.defaultPromptBody;
          }
          if (_this.defaultQuestions.length) {
            _this.form.questions = _this.defaultQuestions.map(wrapQuestion);
          } else if (!_this.form.questions.length) {
            _this.form.questions = [Object(__WEBPACK_IMPORTED_MODULE_1__audio_asr_check_prompt__["a" /* createEmptyQuestion */])(questionKey++)];
          }
        }
      }).catch(function () {
        _this.promptConfigLoaded = true;
        if (!_this.isEdit && !_this.form.questions.length) {
          _this.form.questions = [Object(__WEBPACK_IMPORTED_MODULE_1__audio_asr_check_prompt__["a" /* createEmptyQuestion */])(questionKey++)];
        }
      });
    },
    loadDetail: function loadDetail() {
      var _this2 = this;

      this.pageLoading = true;
      request.common('getAudioAsrCheckTemplate', { id: this.templateId }).then(function (_ref2) {
        var data = _ref2.data;

        _this2.isReferenced = Number(data.is_referenced) === 1;
        _this2.form.title = data.title || '';
        _this2.form.prompt_template = data.prompt_template || '';
        _this2.form.questions = (data.questions || []).map(wrapQuestion);
        if (!_this2.form.questions.length) {
          _this2.form.questions = [Object(__WEBPACK_IMPORTED_MODULE_1__audio_asr_check_prompt__["a" /* createEmptyQuestion */])(questionKey++)];
        }
      }).finally(function () {
        _this2.pageLoading = false;
      });
    },
    resetPromptTemplate: function resetPromptTemplate() {
      this.form.prompt_template = this.defaultPromptBody;
      if (!this.isEdit && this.defaultQuestions.length) {
        this.form.questions = this.defaultQuestions.map(wrapQuestion);
      }
    },
    addQuestion: function addQuestion() {
      this.form.questions.push(Object(__WEBPACK_IMPORTED_MODULE_1__audio_asr_check_prompt__["a" /* createEmptyQuestion */])(questionKey++));
    },
    removeQuestion: function removeQuestion(index) {
      if (this.form.questions.length <= 1) {
        return;
      }
      this.form.questions.splice(index, 1);
    },
    onExportQuestions: function onExportQuestions() {
      var rows = Object(__WEBPACK_IMPORTED_MODULE_2__audio_asr_check_question_io__["b" /* buildQuestionExportRows */])(this.form.questions);
      var title = (this.form.title || '录音风险配置').trim();
      if (!rows.length) {
        rows = [{
          alias: '未提问',
          question: '录音中是否有询问粮油？',
          risk_answer: '否'
        }, {
          alias: '必填',
          question: '必填',
          risk_answer: '必填'
        }];
        this.$export(title + '-\u95EE\u9898\u5BFC\u5165\u6A21\u677F', rows, {
          fileHeader: __WEBPACK_IMPORTED_MODULE_2__audio_asr_check_question_io__["a" /* QUESTION_EXPORT_HEADERS */]
        });
        return;
      }
      this.$export(title + '-\u95EE\u9898\u5217\u8868', rows, {
        fileHeader: __WEBPACK_IMPORTED_MODULE_2__audio_asr_check_question_io__["a" /* QUESTION_EXPORT_HEADERS */]
      });
    },
    onImportQuestions: function onImportQuestions(requestOption) {
      var _this3 = this;

      var file = requestOption && requestOption.file;
      if (!file) {
        return;
      }
      if (this.isReadonly) {
        this.$message.warning('当前配置不可修改');
        return;
      }
      this.importingQuestions = true;
      Object(__WEBPACK_IMPORTED_MODULE_2__audio_asr_check_question_io__["d" /* readFileAsArrayBuffer */])(file).then(function (buffer) {
        var result = Object(__WEBPACK_IMPORTED_MODULE_2__audio_asr_check_question_io__["c" /* parseQuestionImportWorkbook */])(buffer);
        if (result.error) {
          _this3.$message.error(result.error);
          return;
        }
        // 过滤说明行（风险名称为“必填”之类）
        var questions = result.questions.filter(function (item) {
          var alias = (item.alias || '').trim();
          var question = (item.question || '').trim();
          if (alias === '必填' && question === '必填') {
            return false;
          }
          return true;
        });
        if (!questions.length) {
          _this3.$message.error('未解析到有效问题，请检查数据行');
          return;
        }
        // 直接替换界面数据，不带旧 question.id，手动保存后才会落库
        _this3.form.questions = questions.map(function (item) {
          return Object(__WEBPACK_IMPORTED_MODULE_1__audio_asr_check_prompt__["a" /* createEmptyQuestion */])(questionKey++, item);
        });
        _this3.$message.success('\u5DF2\u5BFC\u5165 ' + questions.length + ' \u6761\u95EE\u9898\uFF08\u5C1A\u672A\u4FDD\u5B58\uFF0C\u8BF7\u786E\u8BA4\u540E\u70B9\u51FB\u4FDD\u5B58\uFF09');
      }).catch(function (error) {
        _this3.$message.error(error && error.message ? error.message : '导入失败');
      }).finally(function () {
        _this3.importingQuestions = false;
      });
    },
    buildPayload: function buildPayload() {
      return {
        title: (this.form.title || '').trim(),
        prompt_template: (this.form.prompt_template || '').trim(),
        questions: this.form.questions.map(function (item, index) {
          var row = {
            seq: index + 1,
            alias: (item.alias || '').trim(),
            question: (item.question || '').trim(),
            risk_answer: (item.risk_answer || '').trim()
          };
          if (item.id) {
            row.id = item.id;
          }
          return row;
        })
      };
    },
    validateQuestionsLocal: function validateQuestionsLocal() {
      var questions = this.form.questions || [];
      if (!questions.length) {
        this.$message.error('请至少配置一个问题');
        return false;
      }
      for (var i = 0; i < questions.length; i++) {
        var no = i + 1;
        var item = questions[i];
        if (!(item.alias || '').trim()) {
          this.$message.error('\u7B2C' + no + '\u4E2A\u98CE\u9669\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A');
          return false;
        }
        if (!(item.question || '').trim()) {
          this.$message.error('\u7B2C' + no + '\u4E2A\u95EE\u9898\u5185\u5BB9\u4E0D\u80FD\u4E3A\u7A7A');
          return false;
        }
        if (!(item.risk_answer || '').trim()) {
          this.$message.error('\u7B2C' + no + '\u4E2A\u95EE\u9898\u98CE\u9669\u7B54\u6848\u4E0D\u80FD\u4E3A\u7A7A');
          return false;
        }
      }
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__audio_asr_check_prompt__["b" /* validatePromptTemplate */])(this.form.prompt_template)) {
        this.$message.error('提示词模板必须包含 {{问题列表}} 与 {{ASR识别结果}}');
        return false;
      }
      return true;
    },
    onPreviewPrompt: function onPreviewPrompt() {
      var _this4 = this;

      if (!this.validateQuestionsLocal()) {
        return;
      }
      this.previewLoading = true;
      this.promptPreviewVisible = true;
      this.previewPrompt = '';
      request.common('previewAudioAsrCheckPrompt', this.buildPayload()).then(function (_ref3) {
        var data = _ref3.data;

        _this4.previewPrompt = data.prompt || '';
      }).finally(function () {
        _this4.previewLoading = false;
      });
    },
    onSubmit: function onSubmit() {
      var _this5 = this;

      if (this.isReadonly) {
        return;
      }
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          return;
        }
        if (!_this5.validateQuestionsLocal()) {
          return;
        }
        var payload = _this5.buildPayload();
        _this5.submitting = true;
        var req = _this5.isEdit ? request.common('updateAudioAsrCheckTemplate', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: _this5.templateId }, payload)) : request.common('createAudioAsrCheckTemplate', payload);
        req.then(function () {
          _this5.$message.success('保存成功');
          _this5.$router.push('/audio-asr-check/template');
        }).finally(function () {
          _this5.submitting = false;
        });
      });
    }
  }
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AudioAsrCheckTemplateForm_vue__ = __webpack_require__(2515);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f98e40b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AudioAsrCheckTemplateForm_vue__ = __webpack_require__(3177);
function injectStyle (ssrContext) {
  __webpack_require__(3173)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f98e40b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AudioAsrCheckTemplateForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f98e40b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AudioAsrCheckTemplateForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3173:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3174);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3f3698c3", content, true, {});

/***/ }),

/***/ 3174:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".asr-check-form__alert[data-v-f98e40b0]{margin-bottom:12px}.asr-check-form__card[data-v-f98e40b0]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.08);box-shadow:0 1px 3px rgba(0,0,0,.08);overflow:hidden}.asr-check-form__card-header[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500}.asr-check-form__card-header i[data-v-f98e40b0]{color:#909399}.asr-check-form__body[data-v-f98e40b0]{padding:20px 24px 0}.asr-check-form__section+.asr-check-form__section[data-v-f98e40b0]{margin-top:24px}.asr-check-form__section-title[data-v-f98e40b0]{margin:0 0 16px;padding-bottom:8px;border-bottom:1px solid #ebeef5;color:#303133;font-size:16px;font-weight:600;line-height:1.5}.asr-check-form__section-title--inline[data-v-f98e40b0]{margin-bottom:4px;padding-bottom:0;border-bottom:none}.asr-check-form__section-head[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:16px;margin-bottom:16px;padding-bottom:8px;border-bottom:1px solid #ebeef5}.asr-check-form__section-actions[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;-ms-flex-negative:0;flex-shrink:0}.asr-check-form__import-upload[data-v-f98e40b0]{display:inline-block}.asr-check-form__section-desc[data-v-f98e40b0]{margin:0;color:#909399;font-size:12px;line-height:1.5;font-weight:400}.asr-check-form__row[data-v-f98e40b0]{display:grid;grid-template-columns:minmax(120px,16.666%) minmax(0,1fr);gap:16px;-webkit-box-align:start;-ms-flex-align:start;align-items:start;margin-bottom:16px}.asr-check-form__label[data-v-f98e40b0]{padding-top:8px;color:#606266;font-size:14px;line-height:1.5}.asr-check-form__label.is-required[data-v-f98e40b0]:before{content:\"*\";color:#f56c6c;margin-right:4px}.asr-check-form__field[data-v-f98e40b0]{min-width:0}.asr-check-form__form-item[data-v-f98e40b0]{margin-bottom:0}.asr-check-form__title-input[data-v-f98e40b0]{max-width:480px}.asr-check-form__prompt-toolbar[data-v-f98e40b0]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:8px}.asr-check-form__prompt-toolbar[data-v-f98e40b0],.asr-check-form__prompt-vars[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.asr-check-form__prompt-vars[data-v-f98e40b0]{-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px}.asr-check-form__prompt-var[data-v-f98e40b0]{display:inline-block;padding:2px 8px;border-radius:4px;background:#ecf5ff;color:#409eff;font-size:12px}.asr-check-form__prompt-var-tip[data-v-f98e40b0]{color:#909399;font-size:12px}.asr-check-form__prompt-collapse[data-v-f98e40b0]{margin-top:8px}.asr-check-form__prompt-fixed-title[data-v-f98e40b0]{color:#606266;font-size:13px}.asr-check-form__prompt-fixed-content[data-v-f98e40b0],.asr-check-form__prompt-preview-content[data-v-f98e40b0]{margin:0;padding:12px;background:#f5f7fa;border-radius:4px;white-space:pre-wrap;word-break:break-word;font-size:12px;line-height:1.6;max-height:420px;overflow:auto}.asr-check-form__question-table[data-v-f98e40b0]{border:1px solid #ebeef5;border-radius:4px;overflow:hidden}.asr-check-form__question-head[data-v-f98e40b0],.asr-check-form__question-item[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;padding:10px 12px}.asr-check-form__question-head[data-v-f98e40b0]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f5f7fa;color:#909399;font-size:12px;line-height:1;min-height:36px;-webkit-box-sizing:border-box;box-sizing:border-box}.asr-check-form__question-item[data-v-f98e40b0]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;border-top:1px solid #ebeef5}.asr-check-form__question-col.is-index[data-v-f98e40b0]{width:36px;-webkit-box-flex:0;-ms-flex:none;flex:none}.asr-check-form__question-col.is-alias[data-v-f98e40b0]{width:160px;-webkit-box-flex:0;-ms-flex:none;flex:none}.asr-check-form__question-col.is-question[data-v-f98e40b0]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:220px}.asr-check-form__question-col.is-risk[data-v-f98e40b0]{width:180px;-webkit-box-flex:0;-ms-flex:none;flex:none}.asr-check-form__question-col.is-action[data-v-f98e40b0]{width:40px;-webkit-box-flex:0;-ms-flex:none;flex:none;text-align:center}.asr-check-form__question-item .asr-check-form__question-col.is-index[data-v-f98e40b0]{padding-top:6px}.asr-check-form__question-item .asr-check-form__question-col.is-action[data-v-f98e40b0]{padding-top:4px}.asr-check-form__question-badge[data-v-f98e40b0]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:22px;height:22px;border-radius:50%;background:#409eff;color:#fff;font-size:12px}.asr-check-form__question-remove[data-v-f98e40b0]{color:#f56c6c}.asr-check-form__empty-hint[data-v-f98e40b0]{color:#909399;font-size:13px;padding:12px 0}.asr-check-form__footer[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:12px;margin:8px -24px 0;padding:12px 24px;background:#f5f7fa;border-top:1px solid #ebeef5;border-radius:0 0 8px 8px}.asr-check-form__footer-tip[data-v-f98e40b0]{color:#909399;font-size:12px}.asr-check-form__footer-actions[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;-ms-flex-negative:0;flex-shrink:0}@media (max-width:768px){.asr-check-form__row[data-v-f98e40b0]{grid-template-columns:1fr;gap:8px}.asr-check-form__label[data-v-f98e40b0]{padding-top:0}.asr-check-form__section-head[data-v-f98e40b0]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.asr-check-form__section-actions[data-v-f98e40b0]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.asr-check-form__footer[data-v-f98e40b0]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}}", "", {"version":3,"sources":["/workspace/src/views/audio-asr-check/pages/AudioAsrCheckTemplateForm.vue"],"names":[],"mappings":"AACA,wCAAwC,kBAAkB,CACzD,AACD,uCAAuC,gBAAgB,kBAAkB,6CAA8C,qCAAsC,eAAe,CAC3K,AACD,8CAA8C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,kBAAkB,gCAAgC,eAAe,yBAAyB,sBAAsB,qBAAqB,iBAAiB,cAAc,eAAe,eAAe,CACnb,AACD,gDAAgD,aAAa,CAC5D,AACD,uCAAuC,mBAAmB,CACzD,AACD,mEAAmE,eAAe,CACjF,AACD,gDAAgD,gBAAgB,mBAAmB,gCAAgC,cAAc,eAAe,gBAAgB,eAAe,CAC9K,AACD,wDAAwD,kBAAkB,iBAAiB,kBAAkB,CAC5G,AACD,+CAA+C,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,yBAAyB,sBAAsB,8BAA8B,SAAS,mBAAmB,mBAAmB,+BAA+B,CAClU,AACD,kDAAkD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,mBAAmB,eAAe,QAAQ,oBAAoB,aAAa,CACnP,AACD,gDAAgD,oBAAoB,CACnE,AACD,+CAA+C,SAAS,cAAc,eAAe,gBAAgB,eAAkB,CACtH,AACD,sCAAsC,aAAa,0DAA4D,SAAS,wBAAwB,qBAAqB,kBAAkB,kBAAkB,CACxM,AACD,wCAAwC,gBAAgB,cAAc,eAAe,eAAe,CACnG,AACD,2DAA4D,YAAY,cAAc,gBAAgB,CACrG,AACD,wCAAwC,WAAW,CAClD,AACD,4CAA4C,eAAe,CAC1D,AACD,8CAA8C,eAAe,CAC5D,AACD,iDAAwK,yBAAyB,sBAAsB,8BAA8B,iBAAiB,CACrQ,AACD,+FAFiD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,kBAAmB,CAGvK,AADD,8CAAqK,mBAAmB,eAAe,OAAO,CAC7M,AACD,6CAA6C,qBAAqB,gBAAgB,kBAAkB,mBAAmB,cAAc,cAAc,CAClJ,AACD,iDAAiD,cAAc,cAAc,CAC5E,AACD,kDAAkD,cAAc,CAC/D,AACD,qDAAqD,cAAc,cAAc,CAChF,AACD,gHAAgH,SAAS,aAAa,mBAAmB,kBAAkB,qBAAqB,sBAAsB,eAAe,gBAAgB,iBAAiB,aAAa,CAClR,AACD,iDAAiD,yBAAyB,kBAAkB,eAAe,CAC1G,AACD,gGAAgG,oBAAoB,oBAAoB,aAAa,QAAQ,iBAAiB,CAC7K,AACD,gDAAgD,yBAAyB,sBAAsB,mBAAmB,mBAAmB,cAAc,eAAe,cAAc,gBAAgB,8BAA8B,qBAAqB,CAClP,AACD,gDAAgD,wBAAwB,qBAAqB,uBAAuB,4BAA4B,CAC/I,AACD,wDAAwD,WAAW,mBAAmB,cAAc,SAAS,CAC5G,AACD,wDAAwD,YAAY,mBAAmB,cAAc,SAAS,CAC7G,AACD,2DAA2D,mBAAmB,WAAW,OAAO,eAAe,CAC9G,AACD,uDAAuD,YAAY,mBAAmB,cAAc,SAAS,CAC5G,AACD,yDAAyD,WAAW,mBAAmB,cAAc,UAAU,iBAAiB,CAC/H,AACD,uFAAuF,eAAe,CACrG,AACD,wFAAwF,eAAe,CACtG,AACD,iDAAiD,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,YAAY,kBAAkB,mBAAmB,WAAW,cAAc,CACrV,AACD,kDAAkD,aAAa,CAC9D,AACD,6CAA6C,cAAc,eAAe,cAAc,CACvF,AACD,yCAAyC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,SAAS,mBAAmB,kBAAkB,mBAAmB,6BAA6B,yBAAyB,CACnW,AACD,6CAA6C,cAAc,cAAc,CACxE,AACD,iDAAiD,oBAAoB,oBAAoB,aAAa,QAAQ,oBAAoB,aAAa,CAC9I,AACD,yBACA,sCAAsC,0BAA0B,OAAO,CACtE,AACD,wCAAwC,aAAa,CACpD,AACD,+CAA+C,4BAA4B,6BAA6B,0BAA0B,sBAAsB,0BAA0B,uBAAuB,mBAAmB,CAC3N,AACD,kDAAkD,uBAAuB,oBAAoB,0BAA0B,CACtH,AACD,yCAAyC,4BAA4B,6BAA6B,0BAA0B,sBAAsB,0BAA0B,uBAAuB,mBAAmB,CACrN,CACA","file":"AudioAsrCheckTemplateForm.vue","sourcesContent":["\n.asr-check-form__alert[data-v-f98e40b0]{margin-bottom:12px\n}\n.asr-check-form__card[data-v-f98e40b0]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.08);box-shadow:0 1px 3px rgba(0,0,0,0.08);overflow:hidden\n}\n.asr-check-form__card-header[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500\n}\n.asr-check-form__card-header i[data-v-f98e40b0]{color:#909399\n}\n.asr-check-form__body[data-v-f98e40b0]{padding:20px 24px 0\n}\n.asr-check-form__section+.asr-check-form__section[data-v-f98e40b0]{margin-top:24px\n}\n.asr-check-form__section-title[data-v-f98e40b0]{margin:0 0 16px;padding-bottom:8px;border-bottom:1px solid #ebeef5;color:#303133;font-size:16px;font-weight:600;line-height:1.5\n}\n.asr-check-form__section-title--inline[data-v-f98e40b0]{margin-bottom:4px;padding-bottom:0;border-bottom:none\n}\n.asr-check-form__section-head[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:16px;margin-bottom:16px;padding-bottom:8px;border-bottom:1px solid #ebeef5\n}\n.asr-check-form__section-actions[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;-ms-flex-negative:0;flex-shrink:0\n}\n.asr-check-form__import-upload[data-v-f98e40b0]{display:inline-block\n}\n.asr-check-form__section-desc[data-v-f98e40b0]{margin:0;color:#909399;font-size:12px;line-height:1.5;font-weight:normal\n}\n.asr-check-form__row[data-v-f98e40b0]{display:grid;grid-template-columns:minmax(120px, 16.666%) minmax(0, 1fr);gap:16px;-webkit-box-align:start;-ms-flex-align:start;align-items:start;margin-bottom:16px\n}\n.asr-check-form__label[data-v-f98e40b0]{padding-top:8px;color:#606266;font-size:14px;line-height:1.5\n}\n.asr-check-form__label.is-required[data-v-f98e40b0]::before{content:'*';color:#f56c6c;margin-right:4px\n}\n.asr-check-form__field[data-v-f98e40b0]{min-width:0\n}\n.asr-check-form__form-item[data-v-f98e40b0]{margin-bottom:0\n}\n.asr-check-form__title-input[data-v-f98e40b0]{max-width:480px\n}\n.asr-check-form__prompt-toolbar[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:8px\n}\n.asr-check-form__prompt-vars[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px\n}\n.asr-check-form__prompt-var[data-v-f98e40b0]{display:inline-block;padding:2px 8px;border-radius:4px;background:#ecf5ff;color:#409eff;font-size:12px\n}\n.asr-check-form__prompt-var-tip[data-v-f98e40b0]{color:#909399;font-size:12px\n}\n.asr-check-form__prompt-collapse[data-v-f98e40b0]{margin-top:8px\n}\n.asr-check-form__prompt-fixed-title[data-v-f98e40b0]{color:#606266;font-size:13px\n}\n.asr-check-form__prompt-fixed-content[data-v-f98e40b0],.asr-check-form__prompt-preview-content[data-v-f98e40b0]{margin:0;padding:12px;background:#f5f7fa;border-radius:4px;white-space:pre-wrap;word-break:break-word;font-size:12px;line-height:1.6;max-height:420px;overflow:auto\n}\n.asr-check-form__question-table[data-v-f98e40b0]{border:1px solid #ebeef5;border-radius:4px;overflow:hidden\n}\n.asr-check-form__question-head[data-v-f98e40b0],.asr-check-form__question-item[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;padding:10px 12px\n}\n.asr-check-form__question-head[data-v-f98e40b0]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f5f7fa;color:#909399;font-size:12px;line-height:1;min-height:36px;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.asr-check-form__question-item[data-v-f98e40b0]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;border-top:1px solid #ebeef5\n}\n.asr-check-form__question-col.is-index[data-v-f98e40b0]{width:36px;-webkit-box-flex:0;-ms-flex:none;flex:none\n}\n.asr-check-form__question-col.is-alias[data-v-f98e40b0]{width:160px;-webkit-box-flex:0;-ms-flex:none;flex:none\n}\n.asr-check-form__question-col.is-question[data-v-f98e40b0]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:220px\n}\n.asr-check-form__question-col.is-risk[data-v-f98e40b0]{width:180px;-webkit-box-flex:0;-ms-flex:none;flex:none\n}\n.asr-check-form__question-col.is-action[data-v-f98e40b0]{width:40px;-webkit-box-flex:0;-ms-flex:none;flex:none;text-align:center\n}\n.asr-check-form__question-item .asr-check-form__question-col.is-index[data-v-f98e40b0]{padding-top:6px\n}\n.asr-check-form__question-item .asr-check-form__question-col.is-action[data-v-f98e40b0]{padding-top:4px\n}\n.asr-check-form__question-badge[data-v-f98e40b0]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:22px;height:22px;border-radius:50%;background:#409eff;color:#fff;font-size:12px\n}\n.asr-check-form__question-remove[data-v-f98e40b0]{color:#f56c6c\n}\n.asr-check-form__empty-hint[data-v-f98e40b0]{color:#909399;font-size:13px;padding:12px 0\n}\n.asr-check-form__footer[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:12px;margin:8px -24px 0;padding:12px 24px;background:#f5f7fa;border-top:1px solid #ebeef5;border-radius:0 0 8px 8px\n}\n.asr-check-form__footer-tip[data-v-f98e40b0]{color:#909399;font-size:12px\n}\n.asr-check-form__footer-actions[data-v-f98e40b0]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;-ms-flex-negative:0;flex-shrink:0\n}\n@media (max-width: 768px){\n.asr-check-form__row[data-v-f98e40b0]{grid-template-columns:1fr;gap:8px\n}\n.asr-check-form__label[data-v-f98e40b0]{padding-top:0\n}\n.asr-check-form__section-head[data-v-f98e40b0]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch\n}\n.asr-check-form__section-actions[data-v-f98e40b0]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start\n}\n.asr-check-form__footer[data-v-f98e40b0]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REQUIRED_PROMPT_VARS */
/* harmony export (immutable) */ __webpack_exports__["b"] = validatePromptTemplate;
/* harmony export (immutable) */ __webpack_exports__["a"] = createEmptyQuestion;
var REQUIRED_PROMPT_VARS = ['问题列表', 'ASR识别结果'];

function validatePromptTemplate(template) {
  var text = template ? String(template).trim() : '';
  if (!text) {
    return true;
  }
  for (var i = 0; i < REQUIRED_PROMPT_VARS.length; i++) {
    var varName = REQUIRED_PROMPT_VARS[i];
    if (text.indexOf('{{' + varName + '}}') < 0) {
      return false;
    }
  }
  return true;
}

function createEmptyQuestion(key, item) {
  var source = item || {};
  return {
    _key: key,
    alias: source.alias || '',
    question: source.question || '',
    risk_answer: source.risk_answer || ''
  };
}

/***/ }),

/***/ 3176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QUESTION_EXPORT_HEADERS; });
/* harmony export (immutable) */ __webpack_exports__["b"] = buildQuestionExportRows;
/* harmony export (immutable) */ __webpack_exports__["c"] = parseQuestionImportWorkbook;
/* harmony export (immutable) */ __webpack_exports__["d"] = readFileAsArrayBuffer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xlsx__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xlsx__);




var QUESTION_EXPORT_HEADERS = [{ key: 'alias', text: '风险名称' }, { key: 'question', text: '问题' }, { key: 'risk_answer', text: '风险答案' }];

function buildQuestionExportRows(questions) {
  return (questions || []).map(function (item) {
    return {
      alias: item.alias || '',
      question: item.question || '',
      risk_answer: item.risk_answer || ''
    };
  });
}

function normalizeHeader(value) {
  return String(value == null ? '' : value).replace(/\s+/g, '').trim();
}

function pickCell(row, keys) {
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (Object.prototype.hasOwnProperty.call(row, key) && row[key] != null && String(row[key]).trim() !== '') {
      return String(row[key]).trim();
    }
  }
  return '';
}

/**
 * 解析问题导入 Excel，返回 { questions, error }
 * 顺序按 Excel 数据行从上到下；忽略「序号」列（若存在）
 * questions 项：{ alias, question, risk_answer }
 */
function parseQuestionImportWorkbook(arrayBuffer) {
  var workbook = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.read(arrayBuffer, { type: 'array' });
  if (!workbook.SheetNames || !workbook.SheetNames.length) {
    return { questions: [], error: 'Excel 文件为空' };
  }

  var worksheet = workbook.Sheets[workbook.SheetNames[0]];
  var rows = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.sheet_to_json(worksheet, { defval: '' });
  if (!rows.length) {
    return { questions: [], error: '未解析到有效数据行，请确认首行为表头' };
  }

  var headerMap = {};
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rows[0] || {}).forEach(function (rawKey) {
    var normalized = normalizeHeader(rawKey);
    if (normalized === '风险名称' || normalized === '别名' || normalized.toLowerCase() === 'alias') {
      headerMap.alias = rawKey;
    } else if (normalized === '问题' || normalized === '问题内容' || normalized.toLowerCase() === 'question') {
      headerMap.question = rawKey;
    } else if (normalized === '风险答案' || normalized.toLowerCase() === 'risk_answer') {
      headerMap.risk_answer = rawKey;
    }
  });

  if (!headerMap.alias || !headerMap.question || !headerMap.risk_answer) {
    return {
      questions: [],
      error: '表头需包含：风险名称、问题、风险答案'
    };
  }

  var questions = [];
  for (var i = 0; i < rows.length; i++) {
    var row = rows[i];
    var alias = pickCell(row, [headerMap.alias]);
    var question = pickCell(row, [headerMap.question]);
    var riskAnswer = pickCell(row, [headerMap.risk_answer]);
    if (!alias && !question && !riskAnswer) {
      continue;
    }
    questions.push({
      alias: alias,
      question: question,
      risk_answer: riskAnswer
    });
  }

  if (!questions.length) {
    return { questions: [], error: '未解析到有效问题，请检查数据行' };
  }

  return { questions: questions, error: '' };
}

function readFileAsArrayBuffer(file) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function (e) {
      return resolve(e.target.result);
    };
    reader.onerror = function () {
      return reject(new Error('文件读取失败'));
    };
    reader.readAsArrayBuffer(file);
  });
}

/***/ }),

/***/ 3177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"asr-check-form"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("录音风险管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/audio-asr-check/template' }}},[_vm._v("录音风险配置")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),(_vm.isReadonly)?_c('el-alert',{staticClass:"asr-check-form__alert",attrs:{"title":"该配置已被工单引用，仅可查看，不可修改","type":"warning","closable":false,"show-icon":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"asr-check-form__card"},[_c('div',{staticClass:"asr-check-form__card-header",on:{"click":function($event){_vm.formExpanded = !_vm.formExpanded}}},[_c('span',[_vm._v("表单")]),_vm._v(" "),_c('i',{class:_vm.formExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('el-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.formExpanded),expression:"formExpanded"},{name:"loading",rawName:"v-loading",value:(_vm.pageLoading),expression:"pageLoading"}],ref:"form",staticClass:"asr-check-form__body",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"0"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('section',{staticClass:"asr-check-form__section"},[_c('h3',{staticClass:"asr-check-form__section-title"},[_vm._v("基本信息")]),_vm._v(" "),_c('div',{staticClass:"asr-check-form__row"},[_c('label',{staticClass:"asr-check-form__label is-required"},[_vm._v("配置标题")]),_vm._v(" "),_c('div',{staticClass:"asr-check-form__field"},[_c('el-form-item',{staticClass:"asr-check-form__form-item",attrs:{"prop":"title"}},[_c('el-input',{staticClass:"asr-check-form__title-input",attrs:{"clearable":"","disabled":_vm.isReadonly,"maxlength":"255","show-word-limit":"","placeholder":"请输入配置标题"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"asr-check-form__row"},[_c('label',{staticClass:"asr-check-form__label is-required"},[_vm._v("提示词模板")]),_vm._v(" "),_c('div',{staticClass:"asr-check-form__field"},[_c('div',{staticClass:"asr-check-form__prompt-toolbar"},[_c('div',{staticClass:"asr-check-form__prompt-vars"},[_c('span',{pre:true,attrs:{"class":"asr-check-form__prompt-var"}},[_vm._v("{{问题列表}}")]),_vm._v(" "),_c('span',{pre:true,attrs:{"class":"asr-check-form__prompt-var"}},[_vm._v("{{ASR识别结果}}")]),_vm._v(" "),_c('span',{staticClass:"asr-check-form__prompt-var-tip"},[_vm._v("必填变量")])]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini","icon":"el-icon-refresh-left","disabled":_vm.isReadonly || !_vm.promptConfigLoaded},on:{"click":_vm.resetPromptTemplate}},[_vm._v("恢复默认")])],1),_vm._v(" "),_c('el-form-item',{staticClass:"asr-check-form__form-item",attrs:{"prop":"prompt_template"}},[_c('el-input',{attrs:{"type":"textarea","rows":9,"disabled":_vm.isReadonly,"placeholder":"请输入 LLM 提示词模板"},model:{value:(_vm.form.prompt_template),callback:function ($$v) {_vm.$set(_vm.form, "prompt_template", $$v)},expression:"form.prompt_template"}})],1),_vm._v(" "),_c('el-collapse',{staticClass:"asr-check-form__prompt-collapse",model:{value:(_vm.promptFixedExpanded),callback:function ($$v) {_vm.promptFixedExpanded=$$v},expression:"promptFixedExpanded"}},[_c('el-collapse-item',{attrs:{"name":"fixed"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"asr-check-form__prompt-fixed-title"},[_c('i',{staticClass:"el-icon-lock"}),_vm._v("\n                    固定输出格式（自动追加，不可修改）\n                  ")])]),_vm._v(" "),(_vm.fixedPromptSuffix)?_c('pre',{staticClass:"asr-check-form__prompt-fixed-content"},[_vm._v(_vm._s(_vm.fixedPromptSuffix))]):_c('div',{staticClass:"asr-check-form__empty-hint"},[_vm._v("正在加载固定输出格式...")])],2)],1)],1)])]),_vm._v(" "),_c('section',{staticClass:"asr-check-form__section"},[_c('div',{staticClass:"asr-check-form__section-head"},[_c('div',[_c('h3',{staticClass:"asr-check-form__section-title asr-check-form__section-title--inline"},[_vm._v("问题列表")]),_vm._v(" "),_c('p',{staticClass:"asr-check-form__section-desc"},[_vm._v("\n              每条问题对应 LLM 返回 JSON 中的一项；「风险答案」用于后续判读是否触发风险。导入会替换当前列表，仅写入界面，需手动点击保存。\n            ")])]),_vm._v(" "),_c('div',{staticClass:"asr-check-form__section-actions"},[_c('el-button',{attrs:{"size":"small","icon":"el-icon-download"},on:{"click":_vm.onExportQuestions}},[_vm._v("导出")]),_vm._v(" "),_c('el-upload',{staticClass:"asr-check-form__import-upload",attrs:{"action":"","accept":".xlsx,.xls","show-file-list":false,"disabled":_vm.isReadonly || _vm.importingQuestions,"http-request":_vm.onImportQuestions}},[_c('el-button',{attrs:{"size":"small","icon":"el-icon-upload2","loading":_vm.importingQuestions,"disabled":_vm.isReadonly}},[_vm._v("导入")])],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":"","size":"small","icon":"el-icon-plus","disabled":_vm.isReadonly},on:{"click":_vm.addQuestion}},[_vm._v("添加问题")])],1)]),_vm._v(" "),(_vm.form.questions.length)?_c('div',{staticClass:"asr-check-form__question-table"},[_c('div',{staticClass:"asr-check-form__question-head"},[_c('span',{staticClass:"asr-check-form__question-col is-index"},[_vm._v("序号")]),_vm._v(" "),_c('span',{staticClass:"asr-check-form__question-col is-alias"},[_vm._v("风险名称")]),_vm._v(" "),_c('span',{staticClass:"asr-check-form__question-col is-question"},[_vm._v("问题")]),_vm._v(" "),_c('span',{staticClass:"asr-check-form__question-col is-risk"},[_vm._v("风险答案")]),_vm._v(" "),_c('span',{staticClass:"asr-check-form__question-col is-action"},[_vm._v("操作")])]),_vm._v(" "),_vm._l((_vm.form.questions),function(item,index){return _c('div',{key:item._key,staticClass:"asr-check-form__question-item"},[_c('span',{staticClass:"asr-check-form__question-col is-index"},[_c('span',{staticClass:"asr-check-form__question-badge"},[_vm._v(_vm._s(index + 1))])]),_vm._v(" "),_c('div',{staticClass:"asr-check-form__question-col is-alias"},[_c('el-input',{attrs:{"placeholder":"如：未提问","clearable":"","maxlength":"255","size":"small","disabled":_vm.isReadonly},model:{value:(item.alias),callback:function ($$v) {_vm.$set(item, "alias", $$v)},expression:"item.alias"}})],1),_vm._v(" "),_c('div',{staticClass:"asr-check-form__question-col is-question"},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 1, maxRows: 8 },"placeholder":"请输入问题内容","size":"small","disabled":_vm.isReadonly},model:{value:(item.question),callback:function ($$v) {_vm.$set(item, "question", $$v)},expression:"item.question"}})],1),_vm._v(" "),_c('div',{staticClass:"asr-check-form__question-col is-risk"},[_c('el-input',{attrs:{"placeholder":"如：否 / 无风险","clearable":"","size":"small","disabled":_vm.isReadonly},model:{value:(item.risk_answer),callback:function ($$v) {_vm.$set(item, "risk_answer", $$v)},expression:"item.risk_answer"}})],1),_vm._v(" "),_c('span',{staticClass:"asr-check-form__question-col is-action"},[_c('el-button',{staticClass:"asr-check-form__question-remove",attrs:{"type":"text","icon":"el-icon-delete","disabled":_vm.isReadonly || _vm.form.questions.length <= 1},on:{"click":function($event){return _vm.removeQuestion(index)}}})],1)])})],2):_c('div',{staticClass:"asr-check-form__empty-hint"},[_vm._v("\n          暂无问题，请点击「添加问题」\n        ")])]),_vm._v(" "),_c('div',{staticClass:"asr-check-form__footer"},[_c('span',{staticClass:"asr-check-form__footer-tip"},[_vm._v("预览使用固定 ASR 示例拼接完整提示词")]),_vm._v(" "),_c('div',{staticClass:"asr-check-form__footer-actions"},[_c('el-button',{attrs:{"icon":"el-icon-view","loading":_vm.previewLoading,"disabled":_vm.submitting || !_vm.promptConfigLoaded},on:{"click":_vm.onPreviewPrompt}},[_vm._v("预览提示词")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.$router.push('/audio-asr-check/template')}}},[_vm._v("取消")]),_vm._v(" "),(!_vm.isReadonly)?_c('el-button',{attrs:{"type":"primary","native-type":"submit","loading":_vm.submitting}},[_vm._v("保存")]):_vm._e()],1)])])],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"LLM 提示词预览","visible":_vm.promptPreviewVisible,"width":"720px","append-to-body":""},on:{"update:visible":function($event){_vm.promptPreviewVisible=$event}}},[(_vm.previewLoading)?_c('div',{staticClass:"asr-check-form__empty-hint"},[_vm._v("正在生成提示词...")]):(_vm.previewPrompt)?_c('div',{staticClass:"asr-check-form__prompt-preview-wrap"},[_c('pre',{staticClass:"asr-check-form__prompt-preview-content"},[_vm._v(_vm._s(_vm.previewPrompt))])]):_c('div',{staticClass:"asr-check-form__empty-hint"},[_vm._v("暂无可预览的提示词")]),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.promptPreviewVisible = false}}},[_vm._v("关闭")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/audio-asr-check-form.a1438ab11ee248d6e09e.js